import { Directive } from 'vue';

interface Position {
  top: number;
  left: number;
}

const scrollStore = new Map<string, Position>();

export const scrollRestoration: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    const key = binding.value;
    requestAnimationFrame(() => {
      const pos = scrollStore.get(key) || { top: 0, left: 0 };
      el.scrollTop = pos.top;
      el.scrollLeft = pos.left;
    });

    const handler = () => {
      const newPos = { top: el.scrollTop, left: el.scrollLeft };
      scrollStore.set(key, newPos);
    };

    el.addEventListener('scroll', handler);
    (el as any)._scrollRestorationCleanup = () => {
      el.removeEventListener('scroll', handler);
    };

    (el as any).resetScrollPosition = () => {
      scrollStore.set(key, { top: 0, left: 0 });
      requestAnimationFrame(() => {
        el.scrollTop = 0;
        el.scrollLeft = 0;
      });
    };
  },

  unmounted(el) {
    (el as any)._scrollRestorationCleanup?.();
    delete (el as any).resetScrollPosition;
  },
};
